import {
  SIDEKICK_TRANSLATION_NAMESPACE,
  sidekickEnTranslations,
} from '@brightdrop/ai-sidekick';

import enCaAccount from './en-CA/account.json';
import enCaAlerts from './en-CA/alerts.json';
import enCaAsset from './en-CA/asset.json';
import enCaCatalog from './en-CA/catalog.json';
import enCaChargeStations from './en-CA/chargeStations.json';
import enCaCommon from './en-CA/common.json';
import enCaConnectedCameras from './en-CA/connectedCameras.json';
import enCaCustomVideoRequest from './en-CA/customVideoRequest.json';
import enCaDashboard from './en-CA/dashboard.json';
import enCaDocuments from './en-CA/documents.json';
import enCaDriver from './en-CA/driver.json';
import enCaPlans from './en-CA/entitlements.json';
import enCaExpenses from './en-CA/expenses.json';
import enCaFeedback from './en-CA/feedback.json';
import enCaFleet from './en-CA/fleet.json';
import enCaFleetMap from './en-CA/fleetMap.json';
import enCaHomeCharging from './en-CA/homeCharging.json';
import enCaHub from './en-CA/hub.json';
import enCaInsight from './en-CA/insight.json';
import enCaInspection from './en-CA/inspection.json';
import enCaIntegration from './en-CA/integration.json';
import enCaIntegrations from './en-CA/integrations.json';
import enCaMap from './en-CA/map.json';
import enCaMfa from './en-CA/mfa.json';
import enCaOrder from './en-CA/order.json';
import enCaOrganization from './en-CA/organization.json';
import enCaPeripheral from './en-CA/peripheral.json';
import enCaPurchasePrograms from './en-CA/purchasePrograms.json';
import enCaQuickPay from './en-CA/quickPay.json';
import enCaReports from './en-CA/reports.json';
import enCaSafety from './en-CA/safety.json';
import enCaSettings from './en-CA/settings.json';
import enCaTripHistory from './en-CA/tripHistory.json';
import enCaUser from './en-CA/user.json';
import enAccount from './en-US/account.json';
import enAlerts from './en-US/alerts.json';
import enAsset from './en-US/asset.json';
import enCatalog from './en-US/catalog.json';
import enChargeStations from './en-US/chargeStations.json';
import enCommon from './en-US/common.json';
import enConnectedCameras from './en-US/connectedCameras.json';
import enCustomVideoRequest from './en-US/customVideoRequest.json';
import enDashboard from './en-US/dashboard.json';
import enDocuments from './en-US/documents.json';
import enDriver from './en-US/driver.json';
import enPlans from './en-US/entitlements.json';
import enExpenses from './en-US/expenses.json';
import enFeedback from './en-US/feedback.json';
import enFleet from './en-US/fleet.json';
import enFleetMap from './en-US/fleetMap.json';
import enHomeCharging from './en-US/homeCharging.json';
import enHub from './en-US/hub.json';
import enInsight from './en-US/insight.json';
import enInspection from './en-US/inspection.json';
import enIntegration from './en-US/integration.json';
import enIntegrations from './en-US/integrations.json';
import enMap from './en-US/map.json';
import enMfa from './en-US/mfa.json';
import enOrder from './en-US/order.json';
import enOrganization from './en-US/organization.json';
import enPeripheral from './en-US/peripheral.json';
import enPurchasePrograms from './en-US/purchasePrograms.json';
import enQuickPay from './en-US/quickPay.json';
import enReports from './en-US/reports.json';
import enSafety from './en-US/safety.json';
import enSettings from './en-US/settings.json';
import enTripHistory from './en-US/tripHistory.json';
import enUser from './en-US/user.json';
import esAccount from './es-MX/account.json';
import esAlerts from './es-MX/alerts.json';
import esAsset from './es-MX/asset.json';
import esCatalog from './es-MX/catalog.json';
import esChargeStations from './es-MX/chargeStations.json';
import esCommon from './es-MX/common.json';
import esConnectedCameras from './es-MX/connectedCameras.json';
import esCustomVideoRequest from './es-MX/customVideoRequest.json';
import esDashboard from './es-MX/dashboard.json';
import esDocuments from './es-MX/documents.json';
import esDriver from './es-MX/driver.json';
import esPlans from './es-MX/entitlements.json';
import esExpenses from './es-MX/expenses.json';
import esFeedback from './es-MX/feedback.json';
import esFleet from './es-MX/fleet.json';
import esFleetMap from './es-MX/fleetMap.json';
import esHomeCharging from './es-MX/homeCharging.json';
import esHub from './es-MX/hub.json';
import esInsight from './es-MX/insight.json';
import esInspection from './es-MX/inspection.json';
import esIntegration from './es-MX/integration.json';
import esIntegrations from './es-MX/integrations.json';
import esMap from './es-MX/map.json';
import esMfa from './es-MX/mfa.json';
import esOrder from './es-MX/order.json';
import esOrganization from './es-MX/organization.json';
import esPeripheral from './es-MX/peripheral.json';
import esPurchasePrograms from './es-MX/purchasePrograms.json';
import esQuickPay from './es-MX/quickPay.json';
import esReports from './es-MX/reports.json';
import esSafety from './es-MX/safety.json';
import esSettings from './es-MX/settings.json';
import esTripHistory from './es-MX/tripHistory.json';
import esUser from './es-MX/user.json';
import frAccount from './fr-CA/account.json';
import frAlerts from './fr-CA/alerts.json';
import frAsset from './fr-CA/asset.json';
import frCatalog from './fr-CA/catalog.json';
import frChargeStations from './fr-CA/chargeStations.json';
import frCommon from './fr-CA/common.json';
import frConnectedCameras from './fr-CA/connectedCameras.json';
import frCustomVideoRequest from './fr-CA/customVideoRequest.json';
import frDashboard from './fr-CA/dashboard.json';
import frDocuments from './fr-CA/documents.json';
import frDriver from './fr-CA/driver.json';
import frPlans from './fr-CA/entitlements.json';
import frExpenses from './fr-CA/expenses.json';
import frFeedback from './fr-CA/feedback.json';
import frFleet from './fr-CA/fleet.json';
import frFleetMap from './fr-CA/fleetMap.json';
import frHomeCharging from './fr-CA/homeCharging.json';
import frHub from './fr-CA/hub.json';
import frInsight from './fr-CA/insight.json';
import frInspection from './fr-CA/inspection.json';
import frIntegration from './fr-CA/integration.json';
import frIntegrations from './fr-CA/integrations.json';
import frMap from './fr-CA/map.json';
import frMfa from './fr-CA/mfa.json';
import frOrder from './fr-CA/order.json';
import frOrganization from './fr-CA/organization.json';
import frPeripheral from './fr-CA/peripheral.json';
import frPurchasePrograms from './fr-CA/purchasePrograms.json';
import frQuickPay from './fr-CA/quickPay.json';
import frReports from './fr-CA/reports.json';
import frSafety from './fr-CA/safety.json';
import frSettings from './fr-CA/settings.json';
import frTripHistory from './fr-CA/tripHistory.json';
import frUser from './fr-CA/user.json';

const TranslationBundle = {
  'en-US': {
    common: enCommon,
    order: enOrder,
    organization: enOrganization,
    hub: enHub,
    fleet: enFleet,
    asset: enAsset,
    chargeStations: enChargeStations,
    user: enUser,
    dashboard: enDashboard,
    alerts: enAlerts,
    documents: enDocuments,
    integration: enIntegration,
    insight: enInsight,
    inspection: enInspection,
    settings: enSettings,
    purchasePrograms: enPurchasePrograms,
    peripheral: enPeripheral,
    driver: enDriver,
    safety: enSafety,
    customVideoRequest: enCustomVideoRequest,
    tripHistory: enTripHistory,
    account: enAccount,
    entitlements: enPlans,
    catalog: enCatalog,
    map: enMap,
    mfa: enMfa,
    fleetMap: enFleetMap,
    reports: enReports,
    homeCharging: enHomeCharging,
    feedback: enFeedback,
    quickPay: enQuickPay,
    expenses: enExpenses,
    integrations: enIntegrations,
    connectedCameras: enConnectedCameras,
    // Sidekick chrome copy ships with `@brightdrop/ai-sidekick` so the
    // package's own components resolve without host-side duplication.
    [SIDEKICK_TRANSLATION_NAMESPACE]: sidekickEnTranslations,
  },
  'en-CA': {
    common: enCaCommon,
    order: enCaOrder,
    organization: enCaOrganization,
    hub: enCaHub,
    fleet: enCaFleet,
    asset: enCaAsset,
    chargeStations: enCaChargeStations,
    user: enCaUser,
    dashboard: enCaDashboard,
    alerts: enCaAlerts,
    documents: enCaDocuments,
    integration: enCaIntegration,
    insight: enCaInsight,
    inspection: enCaInspection,
    settings: enCaSettings,
    purchasePrograms: enCaPurchasePrograms,
    peripheral: enCaPeripheral,
    driver: enCaDriver,
    safety: enCaSafety,
    customVideoRequest: enCaCustomVideoRequest,
    tripHistory: enCaTripHistory,
    account: enCaAccount,
    entitlements: enCaPlans,
    catalog: enCaCatalog,
    map: enCaMap,
    mfa: enCaMfa,
    fleetMap: enCaFleetMap,
    reports: enCaReports,
    homeCharging: enCaHomeCharging,
    feedback: enCaFeedback,
    quickPay: enCaQuickPay,
    expenses: enCaExpenses,
    integrations: enCaIntegrations,
    connectedCameras: enCaConnectedCameras,
  },
  'fr-CA': {
    common: frCommon,
    order: frOrder,
    organization: frOrganization,
    hub: frHub,
    fleet: frFleet,
    asset: frAsset,
    chargeStations: frChargeStations,
    user: frUser,
    dashboard: frDashboard,
    alerts: frAlerts,
    documents: frDocuments,
    integration: frIntegration,
    insight: frInsight,
    inspection: frInspection,
    settings: frSettings,
    purchasePrograms: frPurchasePrograms,
    peripheral: frPeripheral,
    driver: frDriver,
    safety: frSafety,
    customVideoRequest: frCustomVideoRequest,
    tripHistory: frTripHistory,
    account: frAccount,
    entitlements: frPlans,
    catalog: frCatalog,
    map: frMap,
    mfa: frMfa,
    fleetMap: frFleetMap,
    reports: frReports,
    homeCharging: frHomeCharging,
    feedback: frFeedback,
    quickPay: frQuickPay,
    expenses: frExpenses,
    integrations: frIntegrations,
    connectedCameras: frConnectedCameras,
  },
  'es-MX': {
    common: esCommon,
    order: esOrder,
    organization: esOrganization,
    hub: esHub,
    fleet: esFleet,
    asset: esAsset,
    chargeStations: esChargeStations,
    user: esUser,
    dashboard: esDashboard,
    alerts: esAlerts,
    documents: esDocuments,
    integration: esIntegration,
    insight: esInsight,
    inspection: esInspection,
    settings: esSettings,
    purchasePrograms: esPurchasePrograms,
    peripheral: esPeripheral,
    driver: esDriver,
    safety: esSafety,
    customVideoRequest: esCustomVideoRequest,
    tripHistory: esTripHistory,
    account: esAccount,
    entitlements: esPlans,
    catalog: esCatalog,
    map: esMap,
    mfa: esMfa,
    fleetMap: esFleetMap,
    reports: esReports,
    homeCharging: esHomeCharging,
    feedback: esFeedback,
    quickPay: esQuickPay,
    expenses: esExpenses,
    integrations: esIntegrations,
    connectedCameras: esConnectedCameras,
  },
};
export default TranslationBundle;
